import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';
import { CanDeactivateGuard } from '../../gards/can-deactivate-guard.service';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.VENUES,
    loadComponent: () =>
      import('./venues.component').then((m) => m.VenuesComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.VENUES,
    loadComponent: () =>
      import('./venues.component').then((m) => m.VenuesComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.VENUES + '/:slug' + '/:id',
    loadComponent: () =>
      import('../venue/venue.component').then((m) => m.VenueComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.VENUES + '/:slug' + '/:id',
    loadComponent: () =>
      import('../venue/venue.component').then((m) => m.VenueComponent),
    canDeactivate: [CanDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VenuesModule {}
